import { i18nTranslate, getLocaleCodeFromUrl } from 'src/utils'
import { countryData } from 'src/views/components/SignUpForms/countryCodeData'

const getDefaultPhoneCountryCode = () => {
  const localeCountryCode = (
    getLocaleCodeFromUrl()?.split('_')?.[1] || ''
  ).toUpperCase()
  const options = countryData()
  const match = options.find(
    option => (option?.value || '').toUpperCase() === localeCountryCode
  )
  return match?.value || options?.[0]?.value || ''
}

export function formInput(props = {}) {
  const { initialValues = {} } = props

  return [
    [
      {
        name: 'recipientName',
        ariaLabel: i18nTranslate(
          'checkout.recipientNameLabel',
          'Recipient name *'
        ),
        dataTestId: 'qa-recipient-name',
        columnType: {
          lg: '9',
        },
        maxLength: 50,
        defaultValue: initialValues?.recipientName || '',
      },
    ],
    [
      {
        name: 'phoneCountryCode',
        type: 'select',
        options: countryData(),
        columnType: {
          lg: '3',
        },
        dataTestId: 'qa-recipient-country-code',
        ariaLabel: 'phoneCountryCode',
        phoneNumberDropDown: true,
        customClassName: 'phone-code-wrapper',
        defaultValue:
          initialValues?.phoneCountryCode || getDefaultPhoneCountryCode(),
      },
      {
        name: 'phoneNumber',
        alias: 'phoneNumber',
        ariaLabel: 'phoneNumber',
        dataTestId: 'qa-recipient-phone-number',
        placeholderKey: 'recipientPhoneNumberPlaceHolder',
        attributeLabelName: i18nTranslate(
          'checkout.recipientPhoneNumberLabel',
          'Recipient Phone Number *'
        ),
        columnType: {
          lg: '6',
        },
        maxLength: 15,
        type: 'mask',
        isToCheckPhoneNumberValid: true,
        customClassName: 'phone-number-wrapper',
        defaultValue: initialValues?.phoneNumber || '',
      },
    ],
  ]
}
